import React, { Component } from "react";
import { connect } from 'react-redux';
import BillingPage from "../components/BillingPage";
import ObjectUtils from '../../shared/utils/ObjectUtils';
import { I18n, syncTranslationWithStore } from 'react-redux-i18n';
import * as actions from '../actions';
import axios from 'axios'
import GraphsForBillingPage from "../components/GraphsForBillingPage";
import Cookies from 'js-cookie'
import authActions from "../../auth/actions";
import { select } from "redux-saga/effects";

class BillingPageContainer extends Component {
    constructor(props) {

        const presentDay = (Date.now() - (1 * 86400000))
        const fifteenDaysBack = new Date(presentDay).toISOString().split('T')[0]

        super(props);
        this.state = {
            months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
            searchFieldsValues: {

                company: {
                    value: []
                },
                building: {
                    value: []
                },
                floor: {
                    value: []
                },
            },
            searchGraphFieldsValues: {
                StartDate: {
                    value: ""
                },
                EndDate: {
                    value: ""
                },
                WorkingHoursFrom: {
                    value: ""
                },
                WorkingHoursEnd: {
                    value: ""
                },
            },
            startDatemaxValue: fifteenDaysBack,
            minValue: "",
            maxValue: "",
            showDays: [],
            showAllData: false,
            billingReportData: [],
            total: 0,
            active: 0,
            inactive: 0,
            diconnected: 0,
            totalData: 0,
            activeData: 0,
            inactiveData: 0,
            disconnectedData: 0,
            companyList: [],
            billingList: [],
            billingData: [],
            mainActiveData: [],
            mainInactiveData: [],
            mainDisconnectedData: [],
            activeDataArray: [],
            inactiveDataArray: [],
            disconnectedDataArray: [],
            comapniesData: [],
            userEntityId: "",
            totalgrapghActiveCount: 0,
            totalgrapghInactiveCount: 0,
            totalgrapghDisconnectedCount: 0,
            mainTotalgrapghActiveCount: 0,
            mainTotalgrapghInactiveCount: 0,
            mainTotalgrapghDisconnectedCount: 0,

        }
    }

    getSessionCall = async () => {
        try{
                if(!axios.defaults.headers.common["Authorization"]){
                const response = await axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-session");
                axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
                return response.data;
            }
        }
        catch(e){
            console.log("refreshing session error: " + e);
        }
    };

    getbillingData = async () => {
        const user = await axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-cookie")
        await this.getSessionCall();   
        console.log("printing props getBiilingData", this.props);
        await axios.get(process.env.REACT_APP_BACKEND_URL + "/meetingRoom/billingReportCount?companyId=" + user.data.entity.id).then(response => {
            /*   console.log("response at company", response) */
            const totalCount = response.data.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.total
            }, 0)
            const activeRooms = response.data.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.active
            }, 0)
            const inActiveRooms = response.data.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.inactive
            }, 0)
            const disconnectedRooms = response.data.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.disconnected
            }, 0)
            const companies = []
            response.data.map(item => item.companyName).filter((value, index, arr) => arr.indexOf(value) === index).map(item => companies.push({ value: item, label: item }));
            /*  console.log("companies", companies) */
            if (companies.length > 1) {
                this.setState({
                    billingReportData: response.data,
                    billingData: response.data,
                    totalData: totalCount,
                    activeData: activeRooms,
                    inactiveData: inActiveRooms,
                    disconnectedData: disconnectedRooms,
                    total: totalCount,
                    active: activeRooms,
                    inactive: inActiveRooms,
                    disconnected: disconnectedRooms,
                    companyList: companies,
                    userEntityId: user.data.entity.id,

                })
            } else if (companies.length === 1) {
                this.setState({
                    billingReportData: response.data,
                    billingData: response.data,
                    totalData: totalCount,
                    activeData: activeRooms,
                    inactiveData: inActiveRooms,
                    disconnectedData: disconnectedRooms,
                    total: totalCount,
                    active: activeRooms,
                    inactive: inActiveRooms,
                    disconnected: disconnectedRooms,
                    companyList: companies,
                    userEntityId: user.data.entity.id,
                    searchFieldsValues: {
                        company: {
                            value: companies[0].value
                        }
                    }
                })

            }
        })
    }

    getGraphAverageDetails = (data) => {
        /*   console.log("data at changing grapgh", data) */
        const graphActiveCount = data.active.reduce((accumulator, currentValue) => {
            return accumulator + currentValue
        }, 0)
        console.log("graphActiveCount", graphActiveCount)
        const graphInactiveCount = data.inactive.reduce((accumulator, currentValue) => {
            return accumulator + currentValue
        }, 0)
        const graphDisconnectedCount = data.disabled.reduce((accumulator, currentValue) => {
            return accumulator + currentValue
        }, 0)

        const totalgrapghActiveCount = Math.round(graphActiveCount / data.active.length);
        const totalgrapghInactiveCount = Math.round(graphInactiveCount / data.inactive.length);
        const totalgrapghDisconnectedCount = Math.round(graphDisconnectedCount / data.disabled.length)
        this.setState({
            totalgrapghActiveCount: totalgrapghActiveCount,
            totalgrapghInactiveCount: totalgrapghInactiveCount,
            totalgrapghDisconnectedCount: totalgrapghDisconnectedCount


        })

    }
    getBillingPageGraph = async () => {
        let userEntityId = this.state.userEntityId
        if(!userEntityId){
            userEntityId = await axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-cookie").then(response => {
                return response.data.entity.id;
            }).catch(e => console.log(e));
        }
        console.log("printing props getBillingPageGraph", this.props);
        await axios.get(process.env.REACT_APP_BACKEND_URL + "/meetingRoom/billingReportGraph?companyId=" + userEntityId).then((response) => {
            /*   console.log("response at billing page graph", response);
              console.log("response.data.active.length", response.data.active.length) */

            const graphActiveCount = response.data.active.reduce((accumulator, currentValue) => {
                return accumulator + currentValue
            }, 0)
            console.log("graphActiveCount", graphActiveCount)
            const graphInactiveCount = response.data.inactive.reduce((accumulator, currentValue) => {
                return accumulator + currentValue
            }, 0)
            const graphDisconnectedCount = response.data.disabled.reduce((accumulator, currentValue) => {
                return accumulator + currentValue
            }, 0)

            const totalgrapghActiveCount = Math.round(graphActiveCount / response.data.active.length);
            const totalgrapghInactiveCount = Math.round(graphInactiveCount / response.data.inactive.length);
            const totalgrapghDisconnectedCount = Math.round(graphDisconnectedCount / response.data.disabled.length)
            const mainTotalgrapghActiveCount = Math.round(graphActiveCount / response.data.active.length);
            const mainTotalgrapghInactiveCount = Math.round(graphInactiveCount / response.data.inactive.length);
            const mainTotalgrapghDisconnectedCount = Math.round(graphDisconnectedCount / response.data.disabled.length)



            this.setState({
                mainActiveData: response.data.active,
                mainInactiveData: response.data.inactive,
                mainDisconnectedData: response.data.inactive,
                activeDataArray: response.data.active,
                inactiveDataArray: response.data.inactive,
                disconnectedDataArray: response.data.disabled,
                totalgrapghActiveCount: totalgrapghActiveCount,
                totalgrapghInactiveCount: totalgrapghInactiveCount,
                totalgrapghDisconnectedCount: totalgrapghDisconnectedCount,
                mainTotalgrapghActiveCount: mainTotalgrapghActiveCount,
                mainTotalgrapghInactiveCount: mainTotalgrapghInactiveCount,
                mainTotalgrapghDisconnectedCount: mainTotalgrapghDisconnectedCount,
                userEntityId: userEntityId


            }, () => {
                /*    console.log("main", this.state.mainActiveData) */
            })

        })

    }

    getChangablebillingData = async (filteredData) => {
        console.log("filteredData", filteredData)

        const totalCount = filteredData.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.total
        }, 0)
        const activeRooms = filteredData.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.active
        }, 0)
        const inActiveRooms = filteredData.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.inactive
        }, 0)
        const disconnectedRooms = filteredData.reduce((accumulator, currentValue) => {

            return accumulator + currentValue.disconnected
        }, 0)

        this.setState({

            total: totalCount,
            active: activeRooms,
            inactive: inActiveRooms,
            disconnected: disconnectedRooms,

        })

    }


    sendingCompanyInfo = () => {
        let companies = [];
        let buildings = [];
        let floors = [];
        let date = this.state?.searchGraphFieldsValues?.StartDate?.value
        companies = this.state.billingData.map(item => item.companyName).filter((item, index, arr) => index === arr.indexOf(item));
        buildings = this.state.billingData.map(item => item.buildingName).filter((item, index, arr) => index === arr.indexOf(item));
        floors = this.state.billingData.map(item => item.floorName).filter((item, index, arr) => index === arr.indexOf(item));
        /*      console.log("companies company", companies)
             console.log("companies building", buildings)
             console.log("companies floors", floors); */

        let companyData = ""; let buildingData = ""; let floorData = ""; let wholeData = ""; let postData = ""

        for (var i = 0; i < companies.length; i++) {
            if (i === 0) {
                companyData = companyData + "companyName=" + companies[i]
            } else if (i > 0) {
                companyData = companyData + "&companyName=" + companies[i]
            }
        }
        if (buildings.length >= 1) {
            for (var j = 0; j < buildings.length; j++) {
                buildingData = buildingData + "&buildingName=" + buildings[j]
            }
        }
        if (floors.length >= 1) {
            for (var k = 0; k < floors.length; k++) {
                floorData = floorData + "&floorName=" + floors[k]
            }
        }
        if (companies.length >= 1 && buildings.length == 0 && floors.length == 0) {
            wholeData = companyData
        } else if (companies.length >= 1 && buildings.length >= 0 && floors.length == 0) {
            wholeData = companyData + buildingData
        } else if (companies.length >= 1 && buildings.length >= 0 && floors.length >= 1) {
            wholeData = companyData + buildingData + floorData
        }

        postData = wholeData;
        return postData
    }

    getCompanyData = async () => {
        let wholeData = this.sendingCompanyInfo();
        const user = this.state.userEntityId
        await axios.get(process.env.REACT_APP_BACKEND_URL + "/meetingRoom/billingReportGraph?companyName=" + user + "&" + wholeData).then(response => {

            this.setState({
                activeDataArray: response.data.active,
                inactiveDataArray: response.data.inactive,
                disconnectedDataArray: response.data.disabled
            }, () => {
                this.getGraphAverageDetails(response.data)
            })
        })
    }

    showWeekOnPageLoad = () => {
        var days = [];
        for (var i = 0; i <= 30; i++) {
            var findDay = (new Date().setDate(new Date().getDate()) - i * 86400000)
            var day = new Date(findDay);
            var actualMonth = this.state.months[new Date(day).getMonth()]
            var actualDate = new Date(day).getDate()
            actualDate = actualDate <= 9 ? ("0" + actualDate) : actualDate;
            day = actualMonth + " " + actualDate
            days.push(day)

        }
        days.reverse();
        return days;
    }

    showWeeks = () => {
        var days = [];
        var startDate = this.state?.searchGraphFieldsValues?.StartDate?.value
        var endDate = this.state?.searchGraphFieldsValues?.EndDate?.value
        var from = new Date(startDate).getTime()
        var to = new Date(endDate).getTime()
        var i = from
        while (i <= to) {
            var findDay = (new Date(i).getTime())
            /* console.log("findDay", findDay) */
            var day = new Date(findDay);
            /*            console.log("findDay", day) */
            var actualMonth = this.state.months[new Date(day).getMonth()]
            var actualDate = new Date(day).getDate()
            actualDate = actualDate <= 9 ? ("0" + actualDate) : actualDate;
            day = actualMonth + " " + actualDate
            days.push(day)
            i = i + 86400000
        }
        console.log("days", days)
        return days

    }

    componentDidMount() {
        this.props.refreshUserState();
        this.fetchData();
        this.getbillingData();
        this.getBillingPageGraph();
        this.setState({
            showDays: this.showWeekOnPageLoad()
        })

    }

    componentDidUpdate(prevProps, prevState) {

        if ((prevState.searchFieldsValues?.company?.value !== this.state.searchFieldsValues?.company?.value && this.state.searchFieldsValues?.company?.value)) {
            const buildingArray = this.state.billingReportData.filter((value) => {
                return (this.state.searchFieldsValues?.company?.value?.includes(value.companyName))
            })
            const allBuildings = []
            const list = buildingArray?.map(item => allBuildings.push({ value: item.buildingName, label: item.buildingName }))

            const showOnlyOneBuiding = allBuildings?.filter((item, index, arr) => index === arr.findIndex(obj => (obj.value === item.value)))

            const companyData = this.state?.billingReportData?.filter((value, arr) => {
                return (!(this.state.searchFieldsValues?.company?.value?.includes(value.companyName)))
            })

            const buildingName = companyData?.filter(item => this.state.searchFieldsValues?.building?.value?.includes(item.buildingName))
            const floorName = companyData?.filter(item => this.state.searchFieldsValues?.floor?.value?.includes(item.floorName))

            let included = buildingName?.map(item => item.buildingName)
            let includedFloors = floorName?.map(item => item.floorName)

            const listTodisplay = this.state.searchFieldsValues?.building?.value?.filter(item => !included?.includes(item))

            this.setState({
                /*    billingList: allBuildings, */
                billingList: showOnlyOneBuiding,
                searchFieldsValues: {
                    ...this.state.searchFieldsValues,
                    building: {
                        value: listTodisplay
                    },
                    floor: {
                        value: this.state.searchFieldsValues?.floor?.value?.filter(item => !includedFloors?.includes(item))
                    }

                }
            })
        }

        if ((prevState.searchFieldsValues?.building?.value !== this.state.searchFieldsValues?.building?.value && this.state.searchFieldsValues?.building?.value)) {
            const floorArray = this.state.billingReportData.filter((value) => {
                return (this.state.searchFieldsValues?.building?.value.includes(value.buildingName))
            })

            const allFloors = []
            const list = floorArray?.map(item => allFloors.push({ value: item.floorName, label: item.floorName }))
            const buildingData = this.state?.billingReportData?.filter((value, arr) => {
                return (!(this.state.searchFieldsValues?.building?.value?.includes(value.buildingName)))
            })
            const floorCheck = buildingData?.filter(item => this.state.searchFieldsValues?.floor?.value?.includes(item.floorName))
            let CheckincludedFloors = floorCheck?.map(item => item.floorName)

            this.setState({
                floorList: allFloors,
                searchFieldsValues: {
                    ...this.state.searchFieldsValues,
                    floor: {
                        value: this.state.searchFieldsValues?.floor?.value?.filter(item => !CheckincludedFloors?.includes(item))
                    }

                }
            })

        }

        if (prevState.searchGraphFieldsValues?.StartDate?.value !== this.state.searchGraphFieldsValues?.StartDate?.value) {
            this.setState({
                searchGraphFieldsValues: {
                    ...this.state.searchGraphFieldsValues,
                    EndDate: {
                        value: ""
                    }
                }
            })
        }
    }

    checkDates = () => {
        this.setState({
            searchGraphFieldsValues: {
                StartDate: {
                    value: ""
                },
                EndDate: {
                    value: ""
                }
            },
            minValue: "",
            maxValue: "",
            showDays: this.showWeekOnPageLoad(),
            billingData: this.state.billingReportData,
            total: this.state.totalData,
            active: this.state.activeData,
            inactive: this.state.inactiveData,
            disconnected: this.state.disconnectedData,

        })
    };

    fetchData = () => {
        const {
            searchFieldsValues,
        } = this.state;

        let filteredData = []
        if (searchFieldsValues?.company?.value.length || (searchFieldsValues.building.value === null || searchFieldsValues.building.value === []) || (searchFieldsValues.floor.value === null || searchFieldsValues.floor.value === [])) {
            filteredData = this.state.billingReportData.filter((value, arr) => {
                return (searchFieldsValues.company.value.includes(value.companyName))
            })
            if (searchFieldsValues.building.value !== null) {
                if (searchFieldsValues.building?.value?.length > 0) {
                    filteredData = filteredData.filter(item => searchFieldsValues.building.value.includes(item.buildingName))

                }
            }
            if (searchFieldsValues.floor.value !== null) {
                if (searchFieldsValues.floor?.value?.length > 0) {
                    filteredData = filteredData.filter(item => searchFieldsValues.floor.value.includes(item.floorName))

                }
            }
        }

        if (filteredData.length > 0) {

            this.getChangablebillingData(filteredData)
            setTimeout(() => {
                this.getCompanyData();
            }, 300)

            this.setState({
                billingData: filteredData,

            }, () => {

            })
        } else {
            this.setState({
                billingData: this.state.billingReportData,
                total: this.state.totalData,
                active: this.state.activeData,
                inactive: this.state.inactiveData,
                disconnected: this.state.disconnectedData,
                activeDataArray: this.state.mainActiveData,
                inactiveDataArray: this.state.mainInactiveData,
                disconnectedDataArray: this.state.mainDisconnectedData
            })
        }
        /*         if (searchFieldsValues.company.value.length === 0 && searchFieldsValues.building.value.length === 0) {
                    this.getbillingData()
                } */

    };
    handleSearchFieldChange = (id, value) => {
     //   console.log("value to check", id, value)
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        }, () => {

            if (this.state.searchFieldsValues?.building?.value === null && this.state.companyList.length > 1) {
                this.setState({
                    searchFieldsValues: {
                        ...this.state.searchFieldsValues,
                        floor: {
                            value: []
                        },

                    },
                    floorList: []
                })
            }
            else if (this.state.searchFieldsValues?.building?.value === null && this.state.companyList.length === 1) {
                let checkDateFields = false
                if (this.state.billingReportData.length !== this.state.billingData.length) {
                    checkDateFields = true
                }
                this.getBillingPageGraph();
                this.setState({
                    searchFieldsValues: {
                        ...this.state.searchFieldsValues,
                        floor: {
                            value: []
                        },

                    },
                    floorList: [],
                    billingData: this.state.billingReportData,
                    total: this.state.totalData,
                    active: this.state.activeData,
                    inactive: this.state.inactiveData,
                    disconnected: this.state.disconnectedData,
                }, () => {
                    if (checkDateFields) {
                        this.checkDates()
                    }

                })
            }
            if (this.state.searchFieldsValues.company.value === null && this.state.searchFieldsValues.building.value === null) {
                let checkDateFields = false
                if (this.state.billingReportData.length !== this.state.billingData.length) {
                    checkDateFields = true
                }
                this.getBillingPageGraph();
                this.setState({
                    billingData: this.state.billingReportData,
                    total: this.state.totalData,
                    active: this.state.activeData,
                    inactive: this.state.inactiveData,
                    disconnected: this.state.disconnectedData,
                    billingList: [],
                    floorList: []

                }, () => {
                    if (checkDateFields) {
                        this.checkDates()
                    }

                })
            }

            else if (this.state.searchFieldsValues.company.value === null && this.state.searchFieldsValues.building.value !== null) {
                let checkDateFields = false
                if (this.state.billingReportData.length !== this.state.billingData.length) {
                    checkDateFields = true
                }
                this.getBillingPageGraph();
                this.setState({
                    searchFieldsValues: {
                        building: {
                            value: []
                        }
                    },
                    billingList: [],
                    floorList: [],
                    billingData: this.state.billingReportData,
                    total: this.state.totalData,
                    active: this.state.activeData,
                    inactive: this.state.inactiveData,
                    disconnected: this.state.disconnectedData,


                }, () => {
                    if (checkDateFields) {
                        this.checkDates()
                    }
                })
            }

            if (id === "company") {
                let checkDateFields = false
                if (this.state.billingReportData.length !== this.state.billingData.length) {
                    checkDateFields = true
                }

                if (value === "") {
                    this.getBillingPageGraph();
                    this.setState({
                        searchFieldsValues: {
                            building: {
                                value: []
                            }
                        },

                        billingList: [],
                        floorList: [],
                        billingData: this.state.billingReportData,
                        total: this.state.totalData,
                        active: this.state.activeData,
                        inactive: this.state.inactiveData,
                        disconnected: this.state.disconnectedData,


                    }, () => {
                        if (checkDateFields) {
                            this.checkDates()


                        }
                    })
                }
            }
            if (id === "building" && this.state.companyList.length > 1) {
                if (value === "") {
                    this.setState({
                        searchFieldsValues: {
                            ...this.state.searchFieldsValues,
                            floor: {
                                value: []
                            },

                        },
                        floorList: []
                    })
                }
            }
            if (id === "building" && this.state.companyList.length === 1) {
                let checkDateFields = false
                if (this.state.billingReportData.length !== this.state.billingData.length) {
                    checkDateFields = true
                }

                if (value === "") {
                    this.getBillingPageGraph();
                    this.setState({
                        searchFieldsValues: {
                            ...this.state.searchFieldsValues,
                            floor: {
                                value: []
                            },

                        },
                        floorList: [],
                        billingData: this.state.billingReportData,
                        total: this.state.totalData,
                        active: this.state.activeData,
                        inactive: this.state.inactiveData,
                        disconnected: this.state.disconnectedData,
                    }, () => {
                        /*   if (checkDateFields) {
                              this.checkDates()
                          } */

                    })
                }
            }

        })


    }

    handleSearchSubmit = () => {
        if ((this.state.companyList.length > 1 && this.state.searchFieldsValues.company.value.length >= 1) || (this.state.companyList.length === 1 && this.state.searchFieldsValues.building.value)) {
            this.fetchData();
            this.handleGraphSearchClear();
        }

    }
    handleSearchClear = () => {
        let checkDateFields = false
        if (this.state.billingReportData.length !== this.state.billingData.length) {
            checkDateFields = true
        }

        this.setState({
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: []
                    }
                }), {})

        }, () => {
            if (this.state.companyList.length === 1) {
                this.setState({
                    searchFieldsValues: {
                        company: {
                            value: this.state.companyList[0].value
                        }
                    }
                })
            }
        })

        if (checkDateFields) {
            this.getBillingPageGraph();
            this.setState({
                searchGraphFieldsValues: {
                    StartDate: {
                        value: ""
                    },
                    EndDate: {
                        value: ""
                    }
                },
                minValue: "",
                maxValue: "",
                showDays: this.showWeekOnPageLoad(),
                billingData: this.state.billingReportData,
                total: this.state.totalData,
                active: this.state.activeData,
                inactive: this.state.inactiveData,
                disconnected: this.state.disconnectedData,


            })
        } else {
            this.setState({
                billingData: this.state.billingReportData,
                total: this.state.totalData,
                active: this.state.activeData,
                inactive: this.state.inactiveData,
                disconnected: this.state.disconnectedData,
                totalgrapghActiveCount: this.state.totalgrapghActiveCount,
                totalgrapghInactiveCount: this.state.totalgrapghInactiveCount,
                totalgrapghDisconnectedCount: this.state.totalgrapghDisconnectedCount
            })
        }
    }

    handleGraphSearchFieldChange = (id, value) => {
        console.log("value for calendar", value)

        this.setState({
            searchGraphFieldsValues: {
                ...this.state.searchGraphFieldsValues,
                [id]: {
                    ...this.state.searchGraphFieldsValues[id],
                    value: value
                }
            }
        }, () => {
            if (this.state.searchGraphFieldsValues.StartDate.value == "") {
                this.setState({
                    searchGraphFieldsValues: {
                        ...this.state.searchGraphFieldsValues,
                        EndDate: {
                            value: ""
                        }
                    }
                })
            }
            if (this.state.searchGraphFieldsValues.StartDate.value !== "") {
                var date = new Date(this.state.searchGraphFieldsValues.StartDate.value)
                var milliseconds = date.getTime();
                var startDateMilliseconds = milliseconds + 86400000;
                var tillEndDate = ""; var startDatePlus = ""
                if (new Date().toISOString().split('T')[0] === new Date(startDateMilliseconds).toISOString().split('T')[0]) {
                    startDatePlus = new Date(startDateMilliseconds).toISOString().split('T')[0]
                    tillEndDate = new Date(startDateMilliseconds).toISOString().split('T')[0]
                    this.setState({ minValue: startDatePlus, maxValue: tillEndDate })
                } else if (Math.floor((new Date().getTime() - new Date(date).getTime()) / (24 * 3600 * 1000)) < 31) {
                    const diff = Math.floor((new Date().getTime() - new Date(date).getTime()) / (24 * 3600 * 1000))
                    console.log("diff", diff)
                    startDatePlus = new Date(startDateMilliseconds).toISOString().split('T')[0]
                    tillEndDate = new Date().toISOString().split('T')[0]
                    this.setState({ minValue: startDatePlus, maxValue: tillEndDate })

                }
                else {
                    var endDateMilliseconds = milliseconds + (30 * 86400000)
                    startDatePlus = new Date(startDateMilliseconds).toISOString().split('T')[0];
                    tillEndDate = new Date(endDateMilliseconds).toISOString().split('T')[0];
                    /*  this.setState({ minValue: this.state.searchGraphFieldsValues.StartDate.value }) */
                    this.setState({ minValue: startDatePlus, maxValue: tillEndDate })
                }
            }


            if (this.state.searchGraphFieldsValues.StartDate.value == "") {
                this.setState({ minValue: "", maxValue: "" })
            }

            if (id === "EndDate") {
                if (value === "") {
                    this.handleGraphSearchClear()
                }
            }

            if (id === "StartDate") {
                if (value === "") {
                    this.handleGraphSearchClear()
                }
            }

        })
    };

    handleGraphSearchSubmit = () => {
        var startDate = (this.state?.searchGraphFieldsValues?.StartDate?.value)
        var endDate = (this.state?.searchGraphFieldsValues?.EndDate?.value)
        console.log("start Date at submit", startDate)
        let wholeData = ""
        if (this.state.billingReportData.length !== this.state.billingData.length) {
            wholeData = this.sendingCompanyInfo() + "&startDate=" + startDate + "&endDate=" + endDate
            console.log(this.sendingCompanyInfo())
        } else {
            wholeData = "startDate=" + startDate + "&endDate=" + endDate
        }
        console.log("wholeData at calendar", wholeData)
        const user = this.state.userEntityId
        if (startDate && endDate) {
            axios.get(process.env.REACT_APP_BACKEND_URL + "/meetingRoom/billingReportGraph?companyId=" + user + "&" + wholeData).then(response => {
                console.log("response at submit dates", response)
                this.getGraphAverageDetails(response.data)
                this.setState({
                    showDays: this.showWeeks(),
                    activeDataArray: response.data.active,
                    inactiveDataArray: response.data.inactive,
                    disconnectedDataArray: response.data.disabled

                })
            })
        }
    }

    handleGraphSearchClear = () => {

        if (this.state.billingReportData !== this.state.billingData) {
            this.fetchData();

            this.setState({
                searchGraphFieldsValues: Object.entries(this.state.searchGraphFieldsValues)
                    .reduce((acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...keyValuePair[1],
                            value: ""
                        }
                    }), {}),
                minValue: "",
                maxValue: "",
                showDays: this.showWeekOnPageLoad(),
            })
        } else {
            this.getBillingPageGraph();
            this.setState({
                searchGraphFieldsValues: Object.entries(this.state.searchGraphFieldsValues)
                    .reduce((acc, keyValuePair) => ({
                        ...acc,
                        [keyValuePair[0]]: {
                            ...keyValuePair[1],
                            value: ""
                        }
                    }), {}),
                minValue: "",
                maxValue: "",
                activeDataArray: this.state.mainActiveData,
                inactiveDataArray: this.state.mainInactiveData,
                disconnectedDataArray: this.state.mainDisconnectedData,
                totalgrapghActiveCount: this.state.totalgrapghActiveCount,
                totalgrapghInactiveCount: this.state.totalgrapghInactiveCount,
                totalgrapghDisconnectedCount: this.state.totalgrapghDisconnectedCount,
                showDays: this.showWeekOnPageLoad(),
            })
        }
    }

    toggleData = () => {
        this.setState({ showAllData: !this.state.showAllData })
    }

    render() {
        /* console.log("start and end dates", this.state.searchGraphFieldsValues) */
        const { searchFieldsValues, searchGraphFieldsValues } = this.state
        /* console.log("this.state.totalgrapghActiveCount", this.state.totalgrapghActiveCount) */
        return (
            <>
                <BillingPage
                    searchFieldsValues={searchFieldsValues}
                    hideAddButton={true}
                    handleSearchFieldChange={this.handleSearchFieldChange}
                    handleSearchSubmit={this.handleSearchSubmit}
                    handleSearchClear={this.handleSearchClear}
                    hideUniversalSearch={true}
                    showAllData={this.state.showAllData}
                    toggleData={this.toggleData}
                    billingReportData={this.state.billingData}
                    total={this.state.total}
                    active={this.state.active}
                    inactive={this.state.inactive}
                    disconnected={this.state.disconnected}
                    companyList={this.state.companyList}
                    billingList={this.state.billingList}
                    floorList={this.state.floorList}
                    totalgrapghActiveCount={this.state.totalgrapghActiveCount}
                    totalgrapghInactiveCount={this.state.totalgrapghInactiveCount}
                    totalgrapghDisconnectedCount={this.state.totalgrapghDisconnectedCount}
                />
                <GraphsForBillingPage
                    searchGraphFieldsValues={searchGraphFieldsValues}
                    hideGraphAddButton={true}
                    handleGraphSearchFieldChange={this.handleGraphSearchFieldChange}
                    handleGraphSearchSubmit={this.handleGraphSearchSubmit}
                    handleGraphSearchClear={this.handleGraphSearchClear}
                    hideGraphUniversalSearch={true}
                    min={this.state.minValue}
                    max={this.state.maxValue}
                    startDatemaxValue={this.state.startDatemaxValue}
                    activeDataArray={this.state.activeDataArray}
                    inactiveDataArray={this.state.inactiveDataArray}
                    disconnectedDataArray={this.state.disconnectedDataArray}
                    showDays={this.state.showDays}

                />

            </>
        )
    }
}


const mapStateToProps = ({ authReducer }) => ({
    user: authReducer.user
})

const mapDispatchToProps = {
        getBillingData: actions.getBillingData,
        getSearchData: actions.getSearchdata,
        resetBillingPageForm: actions.resetBillingPageForm,
        refreshUserState: authActions.getUserPageRefresh
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingPageContainer)


